import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import {
  Div, Loading, P, Input, H4, Button, H3,
} from 'konsys-ui'
import {
  Divider, message, Input as AntInput, Upload,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import { FUEL_ORDER_INFO, GET_PERMS } from '../../constants/graphql/query'
import { checkFloat } from '../../utils/util-services'
import { RECORD_FUEL_LOG } from '../../constants/graphql/mutation'
import history from '../../history'
import PERMISSION from '../../constants/permissions'
import { status } from '../filling-order-page/constants'
import { mappingValueToTypeText } from '../../components/filling-order-components'
import { UploadWithModal } from '../../components/common'


const Center = ({ children }) => (
  <Div display='flex' justifyContent='center' alignItems='center' width='100vw' height='100vh'>{children}</Div>
)

export default (props) => {
  const [amount, setAmount] = useState()
  const [files, setFiles] = useState()
  const [remark, setRemark] = useState()
  const [pricePerLitre, setPricePerLitre] = useState()

  return (
    <Query
      query={GET_PERMS}
    >{({ data: perms, loading: permsLoading, error: permsError }) => (
      <Query
        query={FUEL_ORDER_INFO}
        variables={{
          id: props.match.params.fillingOrderId,
        }}
      >{({ loading, data, error }) => {
        if (loading || permsLoading) return <Center><Loading size='large'/></Center>
        if (error || permsError) return <Center><H3>เกิดข้อผิดพลาด</H3></Center>
        const permKeys = perms.MyPerm.data.perms.map(i => i.name)
        if (!_.includes([status.WAITING, status.PRINTED], data.FuelOrderInfo.status) || !_.includes(permKeys, PERMISSION.RECORD_FILLING_FUEL)) {
          message.error('ใบเบิกน้ำมันไม่สามารถบันทึกการเติมได้')
          history.push('/')
        }
        const info = data.FuelOrderInfo
        return (
          <Div display='flex' flexDirection='column' padding='40px 0' margin='auto' width='80%'>
            <Div display='flex' flexDirection='row' justifyContent='space-between' margin='0 0 24px 0'>
              <P bold style={{ width: 'fit-content' }}>Ref id: {info.ShippingOrder.id}</P>
              <Div display='flex' margin='0 0 8px 0'>
                <P bold style={{ width: 'fit-content' }} margin='0 16px 0'>เล่มที่: {info.shippingVolume}</P>
                <P bold style={{ width: 'fit-content' }}>เลขที่: {info.shippingNumber}</P>
              </Div>
            </Div>
            {/* <P bold style={{ width: 'fit-content' }}>ทะเบียน: {info?.ShippingOrder?.Truck?.plateNumber}</P> */}
            <P display='inline' margin='0 0 8px 0'>ทะเบียน</P>
            <P display='inline' bold margin='0 0 16px 0'>{info?.ShippingOrder?.Truck?.plateNumber}</P>
            <P display='inline' margin='0 0 8px 0'>วันหมดอายุ</P>
            <P display='inline' bold margin='0 0 16px 0'>{!_.isNull(info.expiredDate) ? moment(info.expiredDate).format('DD MM YYYY') : 'ไม่ระบุ'}</P>
            <P display='inline' margin='0 0 8px 0'>ประเภทเชื้อเพลิง</P>
            <P display='inline' bold margin='0 0 16px 0'>{mappingValueToTypeText(info.fuelType)}</P>
            <P display='inline' margin='0 0 8px 0'>ปํ้มน้ำมัน</P>
            <P display='inline' bold margin='0 0 16px 0'>{info.Gasstation.name}</P>
            <P display='inline' margin='0 0 8px 0'>บริษัท</P>
            <P display='inline' bold margin='0 0 16px 0'>{info.Gasstation.company}</P>
            <Divider />
            <P display='inline' margin='0 0 8px 0'>ปริมาณทั้งหมด</P>
            <P display='inline' bold margin='0 0 16px 0'>{info.totalAmount} ลิตร</P>
            <P display='inline' margin='0 0 8px 0'>ปริมาณเหลือที่เบิกได้</P>
            <P display='inline' bold margin='0 0 16px 0'>{info.availableAmount} ลิตร</P>
            <Divider />
            <Div display='flex' flexDirection='column' justifyContent='center'>
              <H4 margin='0 0 8px 0' textAlign='center' bold>ปริมาณที่เติม</H4>
              <Input type='number' value={amount} onChange={(e) => {
                if (_.isNaN(parseFloat(e.target.value)) || (parseFloat(e.target.value) >= 0)) setAmount(parseFloat(e.target.value))
              }} width='100%' margin='0 8px 8px 0' onKeyDown={ (e) => {
                // TODO: TOP create keycode array
                if (!checkFloat(e)) {
                  e.preventDefault()
                }
              }}
              step={0.1}
              min={0}/><P textAlign='center'>ลิตร</P>
            </Div>
            <Div display='flex' flexDirection='column' justifyContent='center'>
              <H4 margin='0 0 8px 0' textAlign='center' bold>ราคาน้ำมันต่อลิตร</H4>
              <Input
              type='number'
              onChange={(e) => {
                if (_.isNaN(parseFloat(e.target.value)) || (parseFloat(e.target.value) >= 0 && parseFloat(e.target.value) <= 80)) setPricePerLitre(parseFloat(e.target.value))
              }}
              width='100%'
              margin='0 8px 8px 0'
              min='0'
              value={pricePerLitre}
              step={0.01}
              onKeyDown={e => !checkFloat(e) && e.preventDefault()}
              />
              <P textAlign='center'>บาทต่อลิตร</P>
            </Div>
            <P display='block'>หมายเหตุ</P>
            <AntInput.TextArea defaultValue={info.remark} rows={4} style={{ margin: '8px 0 16px' }} onChange={e => setRemark(e.target.value)}/>
            <UploadWithModal
              onChange={e => setFiles(e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
              customRequest={() => null}
              processData={false}
              beforeUpload={() => false}
              multiple={true}
              defaultFileList={info.files.map(v => ({
                name: v.filename,
                url: v.url,
                uid: v.url,
              }))}
              listType='picture'
            />
            <Mutation
              mutation={RECORD_FUEL_LOG}
            >{(doUpdate, { loading: logLoading }) => (
              <Button
                text='บันทึก'
                loading={logLoading}
                margin='24px 0'
                disabled={_.isNaN(amount) || _.isUndefined(amount) || logLoading || _.isNaN(pricePerLitre) || _.isUndefined(pricePerLitre)}
                onClick={() => {
                  doUpdate({
                    variables: {
                      fuelId: parseInt(props.match.params.fillingOrderId, 10),
                      amount,
                      files,
                      remark,
                      pricePerLitre: parseFloat(pricePerLitre),
                    },
                  }).then((resp) => {
                    const response = resp.data.CreateFuelOrderLog
                    if (response.success) {
                      message.success(response.message)
                      history.push('/')
                    } else message.error(response.message)
                  })
                }}/>
            )}
            </Mutation>
          </Div>
        )
      }}
      </Query>
    )}
    </Query>
  )
}
